<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Υποθέσεις</h4>
          <CButton class="m-3" color="primary" @click="createCase()">Προσθήκη υπόθεσης</CButton>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CDataTable
            :items="items"
            :fields="fields"
            hover
            striped
            index-column
            table-column
            :items-per-page-select='{ label: "Υποθέσεις ανά σελίδα:" }'
            :loading="loading"
            :sorter="{ external: true, resetable: true }"
            :columnFilter="{ external: true, lazy: true }"
            :tableFilter="{ external: true, lazy: true }"
            @pagination-change="changeItemsLimit"
            :sorter-value.sync="sorter"
            :column-filter-value.sync="columnFilter"
            :table-filter-value.sync="tableFilter"
            @row-clicked="(item) => showCase(item.id)"
            clickable-rows
            ref="table"
          >
          <template #thead-top v-if="isFiltered">
            <CButton class="mb-3 mt-2" color="danger" @click="clean">Καθαρισμός φίλτρων</CButton>
          </template>
          <template #next_visit-filter>
            <div class="selectFilter">
              <input
                type="date"
                :value="selectedDate"
                @change="setDateFilter"
                class="paddingBottomFormControl"
              />
            </div>
          </template>
          <template #status-filter>
            <div class="selectFilter">
              <CSelect
                :options="statusOptions"
                :value.sync="selectedOption" 
              />
            </div>
          </template>
          <template #status="{item}">
            <td>
              <CBadge :color="item.status.class">{{ item.status.name }}</CBadge>
            </td>
          </template>
          <template #client="{item}">
            <td>
              {{ item.client.company }}
            </td>
          </template>
          <template #service-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #service="{item}">
            <td>
              {{ item.service.name }}
            </td>
          </template>
          <template #service_subcategories="{item}">
            <td>
              <span v-for="(subcat, index) in item.service_subcategories" :key="subcat.id">
                {{ subcat.name }} <span v-if="item.service_subcategories.length !== (index+1)">|</span> 
              </span>
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editCase( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        <CPagination
            :pages="maxPages"
            :active-page.sync="activePage"
          />
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

const fields = [
  'case_code',
  {
    key: 'next_visit', 
    label: 'Επόμενη Επίσκεψη', 
    sorter: true, 
    filter: true
  },
  {
    key: 'status', 
    label: 'Κατάσταση', 
    sorter: false, 
    filter: true
  },
  {
    key: 'client', 
    label: 'Πελάτης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'service', 
    label: 'Πρότυπο', 
    sorter: false, 
    filter: true
  },
  {
    key: 'service_subcategories',
    label: 'Υποκατηγορία',
    sorter: false,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'Cases',
  data: () => {
    return {
      items: [],
      fields,
      totalRows: 0,
      you: null,
      message: '',
      selectedOption: 'Καμία επιλογή',
      statusOptions: ['Καμία επιλογή'],
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      loading: true,
      selectedDate: '',
      alertIsShown: false,
      showDismissibleAlert: false,
      activePage: 1,
      maxPages: 1,
      sorter: {column: '', asc: false},
      tableFilter: '',
      columnFilter: {},
      itemsLimit: 10,

    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    },
    activePage(){
      this.getCases();
    },
  	sorter: {
    	handler(){
      	this.getCases();
      },
      deep: true
    },
    tableFilter(){
      this.getCases();
    },
    columnFilter(){
      if (this.selectedOption != "Καμία επιλογή") {
        this.columnFilter['case_status'] = this.selectedOption;
      } else {
        delete this.columnFilter['case_status'];
      }
      if (this.selectedDate) {
        this.columnFilter['next_visit'] = this.selectedDate;
      } else {
        delete this.columnFilter['next_visit'];
      }
      if (this.selectedIsoOption != "Καμία επιλογή") {
        this.columnFilter['service'] = this.selectedIsoOption;
      } else {
        delete this.columnFilter['service'];
      }
      this.getCases();
    },
    selectedOption() {
      if (this.selectedOption != "Καμία επιλογή") {
        this.columnFilter['case_status'] = this.selectedOption;
      } else {
        delete this.columnFilter['case_status'];
      }
      if (this.selectedDate) {
        this.columnFilter['next_visit'] = this.selectedDate;
      } else {
        delete this.columnFilter['next_visit'];
      }
      if (this.selectedIsoOption != "Καμία επιλογή") {
        this.columnFilter['service'] = this.selectedIsoOption;
      } else {
        delete this.columnFilter['service'];
      }
      this.getCases();
    },
    selectedIsoOption() {
      if (this.selectedOption != "Καμία επιλογή") {
        this.columnFilter['case_status'] = this.selectedOption;
      } else {
        delete this.columnFilter['case_status'];
      }
      if (this.selectedDate) {
        this.columnFilter['next_visit'] = this.selectedDate;
      } else {
        delete this.columnFilter['next_visit'];
      }
      if (this.selectedIsoOption != "Καμία επιλογή") {
        this.columnFilter['service'] = this.selectedIsoOption;
      } else {
        delete this.columnFilter['service'];
      }
      this.getCases();
    }
  },
  computed: {
    isFiltered () {
      return this.tableFilter || 
             Object.values(this.columnFilter).join('') || 
             this.sorter.column ||
             this.selectedOption != "Καμία επιλογή" ||
             this.selectedIsoOption != "Καμία επιλογή" ||
             this.selectedDate
    },
  },
  methods: {
    changeItemsLimit( val ){
      this.itemsLimit = val;
      this.getCases();
    },
    setDateFilter(e) {
      this.selectedDate = e.target.value;
      this.columnFilter['next_visit'] = moment(new Date(e.target.value)).format('YYYY-MM-DD');
      this.getCases();
    },
    clean() {
      this.tableFilter = ""
      this.columnFilter = {}
      this.selectedOption = 'Καμία επιλογή'
      this.selectedIsoOption = 'Καμία επιλογή'
      this.selectedDate = ''
      this.sorter = { column: "", asc: true }
    },
    getSubcategory(subcategory) {
      let temp = [];
      let text = '';
      temp = subcategory.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    caseLink (id) {
      return `cases/${id.toString()}`
    },
    editLink (id) {
      return `cases/${id.toString()}/edit`
    },
    showCase ( id ) {
      const caseLink = this.caseLink( id );
      this.$router.push({path: caseLink});
    },
    editCase ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    deleteCase ( id ) {
      let self = this;
      let caseId = id;
      axios.post('/api/cases/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(function (response) {
          self.message = 'Επιτυχής διαγραφή υπόθεσης.';
          self.showAlert();
          self.getCases();
      }).catch(function (error) {
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getCases (){
      let self = this;
      this.loading = true;
      this.items = [];
      console.log(this.columnFilter);
      axios.post('/api/cases/lazyFilter?token=' + localStorage.getItem("api_token") + '&page=' + self.activePage,{
          sorter:       self.sorter,
          tableFilter:  self.tableFilter,
          columnFilter: self.columnFilter,
          itemsLimit:   self.itemsLimit
      })
      .then(function (response) {
        self.loading = false;
        self.maxPages = response.data.cases.last_page;
        self.items = response.data.cases.data.map((item) => {
          if (item.next_visit[0]) {
            item.next_visit = moment(item.next_visit[0], "YYYY-MM-DD").format('DD/MM/YYYY')
          } else {
            item.next_visit = ''
          }
          return item;
        });
      }).catch(function (error) {
        self.loading = false;
        console.log(error);
        self.$router.push({ path: '/login' });
      });
    },
    createCase () {
      this.$router.push({path: 'cases/create'});
    },
    makeFilter(){
      this.getCases();
    },
  },
  mounted: function(){
    this.getCases();
    let self = this;
    axios.get('/api/casestatuses_list?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        let temp = response.data
        self.statusOptions = [...self.statusOptions, ...temp];
      }).catch(function (error) {
        self.loading = false;
        console.log(error);
        self.$router.push({ path: '/login' });
      });

    //TODO: CHANGE THIS
    axios.get('/api/services/list?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.services = response.data;

      self.servicesOptions = ['Καμία επιλογή', ...self.services];
      self.selectedIsoOption = self.servicesOptions[0];

    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}
</script>

<style scoped>
/* Striped rows for better readability */
::v-deep tbody tr:nth-of-type(odd) {
  background-color: #f0f0f0 !important;
}

::v-deep tbody tr:nth-of-type(even) {
  background-color: #ffffff !important;
}

/* Hover effect for both odd and even rows */
::v-deep tbody tr:nth-of-type(odd):hover {
  background-color: #d0e8ff !important;
}

::v-deep tbody tr:nth-of-type(even):hover {
  background-color: #e3f2fd !important;
}
</style>
